import { ComponentProps } from 'react';

import { styled } from '@mui/material';

import { theme as staticTheme } from '../../theme';
import { Box } from '../box/box';
import { StateAwareGridPremium } from '../data-grid-premium/state-aware-grid-premium';
import { useTheme } from '../styles/styles';
import { ProfileTabTitleContainer } from './containers';

export const BasicTableStyled = styled(StateAwareGridPremium)(({ theme }) => ({
  backgroundColor: theme.colors.alpha.white[100],
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'transparent',
  },

  '& .MuiDataGrid-sortIcon': {
    backgroundColor: theme.palette.primary.light,
    width: '16px',
    height: '16px',
    border: `0.5px solid ${theme.border?.sortButton}`,
    borderRadius: theme.borderRadius?.borderRadiusXSmall,
    color: theme.palette.primary.main,
    flex: 1,
  },

  '.MuiCheckbox-root': {
    color: theme.colors.secondary.border,
    '&.Mui-checked': {
      color: theme.employee?.laborLevelColoredText,
    },
  },
}));

export const EmployeeProfileTableStyled = (
  props: ComponentProps<typeof StateAwareGridPremium> & {
    headerTitle?: string;
    headerRightContent?: React.ReactNode;
  }
) => {
  const { headerTitle, headerRightContent } = props;
  const theme = useTheme();
  return (
    <>
      {(headerTitle || headerRightContent) && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
          mb={3}
        >
          <ProfileTabTitleContainer>{headerTitle}</ProfileTabTitleContainer>
          {headerRightContent}
        </Box>
      )}
      <StateAwareGridPremium
        columnHeaderHeight={55}
        rowHeight={65}
        density={'standard'}
        {...props}
        sx={{
          boxShadow: theme.custom?.cardBoxShadow,
          '& .MuiDataGrid-scrollbar': {
            display: 'none !important',
          },
          height: '55vh',
          border: `1px solid ${theme.background.lightGrey3}`,
          borderRadius: '10px',
          '& .MuiDataGrid-columnHeaders': {
            borderBottom: 'none',
          },
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: theme.background.lightGrey4,
          },
          '& .MuiDataGrid-columnHeaders .MuiDataGrid-filler': {
            backgroundColor: theme.background.lightGrey4,
          },
          '& .MuiDataGrid-virtualScroller': {
            '--DataGrid-t-cell-background-pinned': 'white',
            clipPath: 'inset(1px 0 0 0)',
          },
          '& .MuiDataGrid-filler--pinnedRight': {
            borderLeft: 'none',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: '14px',
            fontWeight: 500,
            color: theme.custom?.dataGridHeaderTitle,
            lineHeight: '20px',
            letterSpacing: '-0.15px',
          },
          '& .MuiDataGrid-cell': {
            color: theme.text.darkText,
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '-0.15px',
          },
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeaders .MuiDataGrid-pinnedColumnsSectionSeparator':
            {
              display: 'none',
            },
          ...props.sx,
        }}
      />
    </>
  );
};

export const EmployeeProfileTableHalfPageStyled = styled(
  EmployeeProfileTableStyled
)({
  height: '30vh',
});

export const PinnedRightDesign = (width: number = 60) => ({
  '& .MuiDataGrid-cell--pinnedRight': {
    width,
    minWidth: width,
    maxWidth: width,
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '& .MuiDataGrid-pinnedColumns--right': {
    width: `${width}px !important`,
    minWidth: `${width}px !important`,
    maxWidth: `${width}px !important`,
    '--DataGrid-width-rightPinnedColumns': `${width}px`,
  },
  '& .MuiDataGrid-columnHeader--pinnedRight': {
    width,
    minWidth: width,
    maxWidth: width,
    boxSizing: 'border-box',
  },
  '& .MuiDataGrid-filler--pinnedRight': {
    borderLeft: 0,
  },

  '& .MuiDataGrid-virtualScroller': {
    '--DataGrid-t-cell-background-pinned': staticTheme.background.white,
  },
});
